import { render } from "./LearningPlanDetailsComponent.vue?vue&type=template&id=5d3e3fc0"
import script from "./LearningPlanDetailsComponent.vue?vue&type=script&lang=js"
export * from "./LearningPlanDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__